import React, { useEffect } from "react";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";
import AOS from "aos";
import { profile } from "../data/profile";
import "../App.css";

function Experience() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section id="experience" className="site-section site-section--alt">
      <div className="container site-section-inner">
        <header className="section-head">
          {/* <p className="section-eyebrow">Career</p> */}
          <h2 className="section-title">Technical Experience</h2>
          <p className="section-lead">
            Shipping backends, data pipelines, and AI-assisted products at scale.
          </p>
        </header>

        <div className="experience-list">
          {profile.experience.map((exp, index) => (
            <article
              className="experience-item"
              key={exp.id}
              data-aos="fade-up"
              data-aos-delay={index * 60}
            >
              <div className="experience-item-head">
                <div>
                  <h3 className="experience-title">{exp.title}</h3>
                  <p className="experience-company">{exp.company}</p>
                </div>
                <div className="experience-meta">
                  <p>
                    <FaCalendarAlt aria-hidden />
                    <span>{exp.duration}</span>
                  </p>
                  <p>
                    <FaMapMarkerAlt aria-hidden />
                    <span>{exp.location}</span>
                  </p>
                </div>
              </div>
              <ul>
                {exp.description.map((point) => (
                  <li key={point.slice(0, 40)}>{point}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
